<template>
  <div
    class="modal fade show crop-image-modal"
    style="display: block"
    role="dialog"
    aria-modal="true"
    aria-label="Crop Image">
    <div class="modal-dialog">
      <div class="modal-content crop-dialog">
        <div class="crop-header">
          <h2 class="crop-title">Crop Image</h2>
          <button
            type="button"
            class="im-close"
            aria-label="Close"
            title="Close"
            @click="cancelCropping">
            <icon name="close-icon"/>
          </button>
        </div>


        <div class="modal-body crop-body">
          <div class="crop-stage">
            <cropper
              ref="cropper"
              :src="getSrc"
              :default-position="getDefaultPosition"
              :default-size="getDefaultSize"
              :stencil-props="getAspectRatio"
              :stencil-component="(circleCrop) ? $options.components.CircleStencil : $options.components.RectangleStencil"
              class="cropper"
            />
          </div>
        </div>

        <div class="crop-footer">
          <button
            :class="{ 'is-on': aspectRatioLock || circleCrop }"
            :aria-pressed="aspectRatioLock || circleCrop ? 'true' : 'false'"
            type="button"
            class="crop-lock"
            @click.stop="lockAspectRatio()">
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
              <rect
                x="5"
                y="10.5"
                width="14"
                height="10"
                rx="2.5"/>
              <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>
            </svg>
            {{ (aspectRatioLock || circleCrop) ? 'Unlock' : 'Lock' }} Aspect Ratio
          </button>

          <div class="crop-shape">
            <button
              :class="{ 'is-on': circleCrop }"
              :aria-pressed="circleCrop ? 'true' : 'false'"
              type="button"
              class="crop-shape-btn"
              aria-label="Circle Crop"
              title="Circle Crop"
              @click.stop="enableCrop('circle')">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true">
                <circle
                  cx="12"
                  cy="12"
                  r="8"/>
              </svg>
            </button>
            <button
              :class="{ 'is-on': !circleCrop }"
              :aria-pressed="!circleCrop ? 'true' : 'false'"
              type="button"
              class="crop-shape-btn"
              aria-label="Add Rectangle"
              title="Add Rectangle"
              @click.stop="enableCrop('rectangle')">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true">
                <rect
                  x="4.5"
                  y="5.5"
                  width="15"
                  height="13"
                  rx="2"/>
              </svg>
            </button>
          </div>

          <span class="crop-footer-spacer"/>

          <button
            type="button"
            class="crop-btn crop-btn-cancel"
            @click="cancelCropping">Cancel</button>
          <button
            type="button"
            class="crop-btn crop-btn-apply"
            @click="cropImage">Crop</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CircleStencil, Cropper, RectangleStencil } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import EventBus from '@/EventBus';

export default {
  components: { Cropper, CircleStencil, RectangleStencil },
  data() {
    return { aspectRatioLock: true, circleCrop: this.$store.getters.getCrop.object.circleCrop };
  },
  computed: {

    getAspectRatio() {
      const width  = this.getSelectedObject.Width;
      const height = this.getSelectedObject.Height;
      if (this.aspectRatioLock) {
        const params = { aspectRatio: width / height };
        console.log(params);
        return { aspectRatio: width / height };
      }
      return {};
    },
    getCropperParentStyle() {
      const elem = document.getElementById('canvas-section');
      if (!elem || !this.getSelectedObject) { return ''; }
      let scale = 1;
      if (this.getSelectedObject.Height > this.getSelectedObject.Width) {
        const containerHeight = Math.min(elem.offsetHeight, 500);
        scale                 = containerHeight / this.getSelectedObject.Height;
      } else {
        const containerWidth = Math.min(elem.offsetWidth, 700);
        if (containerWidth < this.getSelectedObject.Width) { scale = containerWidth / elem.offsetWidth; }
      }
      return '';
    },
    getSelectedObject() {
      return this.$store.getters.getCrop.object;
    },
    getSrc() {
      return this.getSelectedObject.DefaultImageUrl;
    },
    getWidth() {
      return this.getSelectedObject.Width;
    },
    getStencilWidth() {
      return parseInt(this.getWidth * this.getStencilScale);
    },
    getStencilHeight() {
      return parseInt(this.getHeight * this.getStencilScale);
    },
    getStencilScale() {
      return this.getSelectedObject.stencilScale;
    },
    getHeight() {
      return this.getSelectedObject.Height;
    },
    getStencilDefaultPositionTop() {
      return this.getSelectedObject.stencilDefaultPositionTop;
    },
    getStencilDefaultPositionLeft() {
      return this.getSelectedObject.stencilDefaultPositionLeft;
    },
    getAppliedCropRect() {
      const { croppedSrc } = this.getSelectedObject;
      if (typeof croppedSrc !== 'string' || croppedSrc.indexOf('&src=') === -1) { return null; }
      const params = new URLSearchParams(croppedSrc.split('?')[1] || '');
      const rect   = {
        width:  Number(params.get('width')),
        height: Number(params.get('height')),
        top:    Number(params.get('top')),
        left:   Number(params.get('left')),
      };
      const isSize = value => Number.isFinite(value) && value > 0;
      const isPos  = value => Number.isFinite(value) && value >= 0;
      return (isSize(rect.width) && isSize(rect.height) && isPos(rect.top) && isPos(rect.left)) ? rect : null;
    },
  },
  mounted() {
    console.log('zooming cropper');
    // this.$refs.cropper.zoom(50);
  },
  methods: {
    getDefaultSize({ imageSize }) {
      const rect = this.getAppliedCropRect;
      if (rect) { return { width: rect.width, height: rect.height }; }

      const frameW = Number(this.getWidth) || imageSize.width;
      const frameH = Number(this.getHeight) || imageSize.height;
      const aspect = frameW / frameH || 1;
      let width    = imageSize.width;
      let height   = width / aspect;
      if (height > imageSize.height) {
        height = imageSize.height;
        width  = height * aspect;
      }
      return { width: width * 0.85, height: height * 0.85 };
    },
    getDefaultPosition({ coordinates, imageSize }) {
      const rect = this.getAppliedCropRect;
      if (rect) { return { top: rect.top, left: rect.left }; }
      return {
        left: Math.max(0, (imageSize.width - coordinates.width) / 2),
        top:  Math.max(0, (imageSize.height - coordinates.height) / 2),
      };
    },
    enableCrop(type) {
      if (type == 'circle') {
        this.circleCrop = true;
      } else {
        this.circleCrop = false;
      }
    },

    lockAspectRatio() {
      if (this.aspectRatioLock) {
        this.aspectRatioLock = false;
      } else {
        this.aspectRatioLock = true;
      }
    },
    getHighResPath() {
      if (this.getSelectedObject.HighResPath && this.getSelectedObject.HighResPath !== 'undefined') { /*
        if (this.getSelectedObject.croppedHighResPath !== 'none' && this.getSelectedObject.croppedHighResPath != 'undefined') {
          return this.getSelectedObject.croppedHighResPath;
        } */
        return this.getSelectedObject.HighResPath;
      }
      return this.getSelectedObject.DefaultImageUrl;
    },

    cropImage() {
      const result      = this.$refs.cropper && this.$refs.cropper.getResult();
      const coordinates = result && result.coordinates;
      if (!coordinates || !result.image) { return; }
      const stencilDefaultPositionTop  = coordinates.top;
      const stencilDefaultPositionLeft = coordinates.left;
      // calculation for high resourse image

      let HeightRatio,
        WidthRatio,
        HighResWidth,
        HighResHeight,
        HighResTop,
        HighResLeft;
      if (this.getSelectedObject.HighResV2Height && this.getSelectedObject.HighResV2Width) {
        if ((this.getSelectedObject.HighResV2Height < parseInt(this.getSelectedObject.DefaultImageHeight)) && (this.getSelectedObject.HighResV2Width < parseInt(this.getSelectedObject.DefaultImageWidth))) {
          HeightRatio   = parseFloat(this.getSelectedObject.DefaultImageHeight) / parseFloat(this.getSelectedObject.HighResV2Height);
          WidthRatio    = parseFloat(this.getSelectedObject.DefaultImageWidth) / parseFloat(this.getSelectedObject.HighResV2Width);
          HighResWidth  = Math.abs(coordinates.width / WidthRatio);
          HighResHeight = Math.abs(coordinates.height / WidthRatio);
          HighResTop    = Math.abs(coordinates.top / HeightRatio);
          HighResLeft   = Math.abs(coordinates.left / WidthRatio);
        } else {
          HeightRatio   = parseFloat(this.getSelectedObject.HighResV2Height) / parseFloat(this.getSelectedObject.DefaultImageHeight);
          WidthRatio    = parseFloat(this.getSelectedObject.HighResV2Width) / parseFloat(this.getSelectedObject.DefaultImageWidth);
          HighResWidth  = WidthRatio * coordinates.width;
          HighResHeight =  HeightRatio * coordinates.height;
          HighResTop    = HeightRatio * coordinates.top;
          HighResLeft   = WidthRatio * coordinates.left;
        }
      } else {
        HighResWidth  = coordinates.width;
        HighResHeight = coordinates.height;
        HighResTop    = coordinates.top;
        HighResLeft   = coordinates.left;
      }
      // Adjusting the coordinates to avoid 0 in order to avoid the black line (Start)
      if (HighResWidth + HighResLeft == HighResWidth) {
        HighResWidth -= 1;
      }
      if (HighResHeight + HighResTop == HighResHeight) {
        HighResHeight -= 1;
      }
      if ((HighResTop == 0)) {
        HighResTop = 1;
      }
      if ((HighResLeft == 0)) {
        HighResLeft = 1;
      }
      if (coordinates.width + coordinates.left == this.getSelectedObject.DefaultImageWidth) {
        coordinates.width -= 1;
      }
      if (coordinates.height + coordinates.top == this.getSelectedObject.DefaultImageHeight) {
        coordinates.height -= 1;
      }
      if (coordinates.top == 0) {
        coordinates.top = 1;
      }
      if (coordinates.left == 0) {
        coordinates.left = 1;
      }
      // Adjusting the coordinates to avoid 0 in order to avoid the black line (Ends)

      const transforms = result.image.transforms || {};
      const scaleX     = Number.isFinite(parseFloat(transforms.scaleX)) ? parseFloat(transforms.scaleX) : 1;
      const scale      = (parseInt(result.image.width, 10) * scaleX) / this.getWidth;
      // let stencilScale=result.image.transforms.scaleX

      const highResPath        = this.getHighResPath();
      const stencilScale       = scale;
      const frame              = document.getElementById(this.getSelectedObject.Id);
      const croppedSrc         = `https://pdf-processing.bankmarketingcenter.com/node/image?width=${coordinates.width}&height=${coordinates.height}&top=${coordinates.top}&left=${coordinates.left}&src=${this.getSelectedObject.DefaultImageUrl}`;
      const croppedHighResPath =          this.getSelectedObject.isBackgroundRemoved
        ? croppedSrc
        : `https://pdf-processing.bankmarketingcenter.com/node/image?width=${HighResWidth}&height=${HighResHeight}&top=${HighResTop}&left=${HighResLeft}&src=${highResPath}`;

      console.log('cropped src is ', croppedSrc);
      console.log('cropped high src is ', croppedHighResPath);
      const data = {
        Id:         this.getSelectedObject.Id,
        stencilDefaultPositionTop,
        stencilDefaultPositionLeft,
        croppedSrc,
        stencilScale,
        tempIndex:  frame ? frame.dataset.elementindex : undefined,
        croppedHighResPath,
        circleCrop: this.circleCrop,
        Width:      this.getSelectedObject.Width,
        Height:     (this.circleCrop) ? this.getSelectedObject.Width : this.getSelectedObject.Height,
        coordinates,
      };
      EventBus.$emit('updateObjectAfterCrop', data);
      this.cancelCropping();
    },
    cancelCropping() {
      this.$store.commit('updateCrop', { isEnable: false, object: null });
    },
  },
};
</script>

<style lang="scss">
.crop-image-modal {
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 106000 !important;
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;

  .modal-dialog {
    max-width: 800px;
  }

  .crop-dialog {
    width: 800px;
    max-width: 100%;
    background: #fff;
    border: 0;
    border-radius: 16px;
    box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.06), 0 24px 64px rgba(16, 24, 40, 0.28);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .crop-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 20px 20px 0 20px;
  }

  .crop-title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.3;
    color: #14161B;
    flex: 1 1 auto;
    min-width: 0;
  }
  .im-close {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    padding: 0;
    cursor: pointer;
    background: transparent;
    color: #3D4350;

    &:hover {
      background: #F3F4F6;
    }

    &:focus {
      outline: none;
      border: 0;
    }

    .icon {
      min-width: 0;
      min-height: 0;
    }

    .icon svg {
      width: 16px;
      height: 16px;
    }
  }

  .crop-body {
    padding: 20px 24px;
    overflow: hidden;
  }

  .crop-stage {
    position: relative;
    height: 440px;
    border-radius: 12px;
    overflow: hidden;
    background: #1B1E24;
  }

  .cropper {
    height: 440px;
    max-height: 440px;
    max-width: 100%;
    overflow: hidden;
    background: #1B1E24;
  }

  .crop-footer {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 24px;
    border-top: 1px solid #E7E9ED;
    background: #FBFBFC;
  }

  .crop-footer-spacer {
    flex: 1 1 auto;
  }

  .crop-lock,
  .crop-shape-btn,
  .crop-btn {
    border: 0;
    font-family: inherit;
    cursor: pointer;

    &:focus {
      outline: none;
      border: 0;
    }
  }

  .crop-lock {
    height: 34px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 0 12px;
    border-radius: 9px;
    background: transparent;
    color: #3D4350;
    font-size: 13px;
    font-weight: 600;

    svg {
      display: block;
      flex-shrink: 0;
    }

    &.is-on {
      background: #EAF2FE;
      color: #0B57C2;
    }
  }

  .crop-shape {
    width: 92px;
    display: flex;
    gap: 2px;
    padding: 3px;
    background: #F3F4F6;
    border-radius: 10px;
  }

  .crop-shape-btn {
    flex: 1 1 0;
    height: 26px;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    padding: 0 6px;
    background: transparent;
    color: #3D4350;

    svg {
      display: block;
      flex-shrink: 0;
    }

    &.is-on {
      background: #fff;
      color: #0B57C2;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1), 0 0 0 1px #E7E9ED;
    }
  }

  .crop-btn {
    height: 38px;
    min-height: 38px;
    min-width: 72px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 14px;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }

  .crop-btn-cancel {
    background: #fff;
    color: #14161B;
    box-shadow: inset 0 0 0 1px #D5D9E0;
  }

  .crop-btn-apply {
    background: #1570EF;
    color: #fff;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
  }
}
</style>
